import axiosApi from '../api/axiosApi';

class AddressByZipCodeApi {
    static getAddresses(zipCode) {
        return axiosApi.get(`ServiceRouter/AddressService/Address/AssociatedCitiesByZip/${zipCode}`, true).then(response => {
            return response;
        }).catch(error => {
            throw error;
        });
    }
}

export default AddressByZipCodeApi;  